document.addEventListener("DOMContentLoaded", function () {
    const initializeSlider = (sliderElement) => {
        const sliderAutoplay = +sliderElement?.dataset.autoplay;
        const sliderArrows = sliderElement?.dataset.arrows;
        const sliderButtonNext = sliderElement?.querySelector('.most-popular__button-next');

        const sliderSettings = {
            loop: true,
            breakpoints: {
                0: {
                    spaceBetween: 16,
                    slidesPerView: 1.8,
                },
                768: {
                    spaceBetween: 32,
                    slidesPerView: 2.3
                },
                1099: {
                    spaceBetween: 32,
                    slidesPerView: 3.319
                }
            }
        };

        if (sliderAutoplay !== 0) {
            sliderSettings.autoplay = {delay: sliderAutoplay * 1000};
        }

        if (sliderArrows && sliderButtonNext) {
            sliderSettings.navigation = {nextEl: sliderButtonNext};
        }

        return new Swiper(sliderElement, sliderSettings);
    };

    const initSliders = () => {
        const sliders = document.querySelectorAll('.most-popular__slider');
        sliders.forEach(initializeSlider);
    };

    initSliders();
});
